import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsExporting from "highcharts/modules/exporting";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { useEffect, useRef } from "react";

NoDataToDisplay(Highcharts);
HighchartsMore(Highcharts);
HighchartsExporting(Highcharts);

const BoxplotChart = ({ data }) => {
  const chartRef = useRef(null);
  const graphData = data?.map((item) => Object.values(item)) || [];

  useEffect(() => {
    if (chartRef.current) {
      if (!data) {
        chartRef.current.chart.showLoading("Loading...");
      } else {
        chartRef.current.chart.hideLoading();
      }
    }
  }, [data]);

  const getOptions = {
    chart: {
      type: "boxplot",
      height: 260,
      borderColor: "#e6e6e6",
      borderRadius: 0,
      borderWidth: 1,
      shadow: {
        color: "#e4e4e4",
        offsetX: 3,
        offsetY: 3,
        opacity: 0.4,
        width: 5,
      },
      spacing: [16, 16, 40, 16],
    },
    title: {
      text: "Box plot - Alerts",
      align: "left",
      margin: 20,
      style: {
        letterSpacing: "0.01071em",
        fontSize: "14px",
      },
    },
    exporting: {
      enabled: false,
    },
    legend: {
      enabled: true,
      layout: "vertical",
      backgroundColor: "#FFFFFF",
      align: "left",
      verticalAlign: "bottom",
      floating: true,
      itemMarginTop: 10,
      padding: 4,
      symbolWidth: 14,
      y: 32,
    },
    colors: ["#56a64b"],
    series: [
      {
        name: "Alerts",
        data: graphData,
        lineWidth: 2,
        legendSymbol: "lineMarker",
        tooltip: {
          headerFormat: "",
          pointFormat: `
            Max: {point.high}<br/>
            Q1 : {point.q3}<br/>
            Median: {point.median}<br/>
            Q3 : {point.q1}<br/>
            Min: {point.low}<br/>
          `,
        },
      },
    ],
    credits: {
      enabled: false,
    },
    xAxis: {
      type: "category",
      gridLineWidth: 0,
      labels: {
        enabled: false,
      },
      lineWidth: 0,
    },
    yAxis: {
      title: {
        text: "",
      },
    },
    lang: {
      noData: data ? "No data" : "",
    },
    noData: {
      style: {
        fontWeight: "normal",
        fontSize: "18px",
        color: "#828282",
      },
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={getOptions} ref={chartRef} />
    </div>
  );
};

export default BoxplotChart;
